(function () {
  angular.module("pcmCommon")
    .constant("systemDefaultOptions", {
      name: "Default",
      vehicleType: 0,
      trkUnits: 0,
      trkLength: "48'0\"",
      trkWidth: "96\"",
      trkHeight: "13'6\"",
      trkWeight: 80000,
      trkAxles: 5,
      trkLCV: false,
      routingType: 0,
      distanceUnits: 0,
      tollDiscourage: false,
      bordersOpen: true,
      overrideRestrict: false,
      highwayOnly: false,
      inclFerryDist: true,
      classOverrides: 0,
      hazMatType: 0,
      tollCurrency: 0,
      exchangeRate: 1.355,
      hubRouting: false,
      fuelUnits: 0,
      costGHG: 22.40,
      costPerFuelUnit: 4.02,
      fuelEconLoad: 6.96,
      fuelEconEmpty: 6.96,
      costMaintLoad: 0.22,
      costMaintEmpty: 0.22,
      costTimeLoad: 47.89,
      costTimeEmpty: 47.89,
      dataVersion: "current",
      inclTollData: false,
      tollPlan: "",
      ferryDiscourage: false,
      elevLimit: null,
      tollRoadType: 3,
      governorSpeedLimit: null,
      sideOfStreetAdherence: 0,
      useTraffic: false,
      useSites: false,
      afSetIDs: "",
      euHazmatType: "None",
      euHazmat: "None",
      EUOptions: {
        fuelType: 4, // Diesel
        refrigerated: false,
        fuelConsumption: 0,
        emiType: 7,
        hasTrailer: false,
        isHybrid: false,
        minPoll: false,
        trlCount: 0,
        trlMaxAxles: 1,
        trlMaxHt: "13'6\"",
        trlMaxWt: 80000,
        trlType: 1
      }
    });
  // Toll road type: '3' represents "Use Toll roads".  This enumeration value is requried in data anywhere and is not available for users in pcmiler web ui to choose. HardCode this value.
})();



// WEBPACK FOOTER //
// ./app/pcm-common/defaultOptions.module.js